(() => {
  if (window.seStickScrollMotionBooted) return;
  window.seStickScrollMotionBooted = true;

  const scenes = new Map();
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer = null;
  let frame = 0;
  let listening = false;

  const clearStick = (state) => {
    state.stick.style.removeProperty('--se-stick-angle');
    state.stick.removeAttribute('data-se-stick-active');
    state.visible = false;
  };

  const render = () => {
    frame = 0;
    if (preference.matches) return;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    scenes.forEach((state) => {
      if (observer && !state.visible) return;
      const bounds = state.scene.getBoundingClientRect();
      const visible = bounds.bottom > 0 && bounds.top < viewportHeight && bounds.height > 0;
      if (!observer) {
        state.visible = visible;
        if (visible) state.stick.setAttribute('data-se-stick-active', '');
        else state.stick.removeAttribute('data-se-stick-active');
      }
      if (!visible) return;
      const progress = Math.min(1, Math.max(0, (viewportHeight - bounds.top) / (viewportHeight + bounds.height)));
      const angle = -24 + progress * 52;
      state.stick.style.setProperty('--se-stick-angle', `${angle.toFixed(3)}deg`);
    });
  };

  const schedule = () => {
    if (preference.matches || frame || !scenes.size) return;
    if (observer && !Array.from(scenes.values()).some((state) => state.visible)) return;
    frame = requestAnimationFrame(render);
  };

  const stop = () => {
    window.removeEventListener('scroll', schedule);
    window.removeEventListener('resize', schedule);
    cancelAnimationFrame(frame);
    frame = 0;
    if (observer) observer.disconnect();
    observer = null;
    listening = false;
    scenes.forEach(clearStick);
  };

  const start = () => {
    if (listening || preference.matches || !scenes.size) return;
    listening = true;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const state = scenes.get(entry.target);
          if (!state) return;
          state.visible = entry.isIntersecting;
          if (state.visible) state.stick.setAttribute('data-se-stick-active', '');
          else state.stick.removeAttribute('data-se-stick-active');
        });
        schedule();
      }, { threshold: 0 });
      scenes.forEach((state) => observer.observe(state.scene));
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  };

  const scenesIn = (scope) => {
    const found = Array.from(scope.querySelectorAll('[data-se-stick-scene]'));
    if (scope.matches && scope.matches('[data-se-stick-scene]')) found.unshift(scope);
    return found;
  };

  const initialize = (scope = document) => {
    scenesIn(scope).forEach((scene) => {
      if (scenes.has(scene)) return;
      const stick = scene.querySelector('[data-se-scroll-stick]');
      if (!stick) return;
      scenes.set(scene, { scene, stick, visible: false });
      if (observer) observer.observe(scene);
    });
    start();
    schedule();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    scenesIn(event.target).forEach((scene) => {
      const state = scenes.get(scene);
      if (!state) return;
      if (observer) observer.unobserve(scene);
      clearStick(state);
      scenes.delete(scene);
    });
    if (!scenes.size) stop();
  });
  const onPreferenceChange = () => {
    stop();
    start();
  };
  if (preference.addEventListener) preference.addEventListener('change', onPreferenceChange);
  else preference.addListener(onPreferenceChange);
})();
